import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { SITE, SERVICES } from "@/lib/site";
import { CITIES } from "@/lib/cities";

export default function Footer() {
  const year = new Date().getFullYear();
  const topCities = CITIES.slice(0, 10);
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 mt-24"
    >
      <div className="stripe-divider" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center h-9 w-9 rounded-md bg-orange-600 text-white font-display font-black text-lg leading-none">
              9
            </span>
            <span className="font-display font-black tracking-tight text-white text-xl">
              901 Lots
            </span>
          </Link>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            Parking lot striping, sealcoating, and pavement marking for
            businesses across Memphis and the Mid-South.
          </p>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-sm uppercase tracking-[0.18em] mb-4">
            Services
          </h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.slice(0, 5).map((s) => (
              <li key={s.slug}>
                <Link
                  to="/services"
                  className="hover:text-white transition-colors"
                  data-testid={`footer-service-${s.slug}`}
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-sm uppercase tracking-[0.18em] mb-4">
            Top Cities
          </h4>
          <ul className="space-y-2 text-sm">
            {topCities.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/service-areas/${c.slug}`}
                  className="hover:text-white transition-colors"
                  data-testid={`footer-city-${c.slug}`}
                >
                  {c.city}, {c.state}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/service-areas" className="text-orange-400 hover:text-orange-300 font-medium">
                See all 20 →
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-sm uppercase tracking-[0.18em] mb-4">
            Company
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/quote" className="hover:text-white">Free Quote</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-sm uppercase tracking-[0.18em] mb-4">
            Contact
          </h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-0.5 text-orange-400" />
              <a
                href={`mailto:${SITE.email}`}
                className="hover:text-white"
                data-testid="footer-email"
              >
                {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-0.5 text-orange-400" />
              <a
                href={SITE.phoneHref}
                className="hover:text-white"
                data-testid="footer-phone"
              >
                {SITE.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-orange-400" />
              <span>Serving Memphis & the Mid-South</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {year} 901 Lots. All rights reserved.</p>
          <p>Licensed & insured · {SITE.domain}</p>
        </div>
      </div>
    </footer>
  );
}
